import React from 'react';
import PredictForm from './components/PredictForm';

function App() {
  return (
    <div style={{ padding: 20 }}>
      <PredictForm />
    </div>
  );
}

export default App;
